module.exports = __webpack_public_path__ + "img/default-photo.b8aba9a0.png";